import { getLanguage } from "@Views/utils/StringUtils";
import { useEffect, useImperativeHandle, useRef } from "react";
import { useHistory } from "react-router";
import { Link } from "react-router-dom";
import GuideLineForUsePopup from "./comp/GuideLineForUsePopupRef";
import RejectionEmailCollectionPopup from "./comp/RejectionEmailCollectionPopupRef";

const Footer = ({ getMsg }: any) => {

  useEffect(() => {

  }, [])

  return (
    <>
      <div className='wrap-foot mtn'>
        <footer className="footer" style={{ minHeight: "52px" }}>
        </footer>
      </div>
    </>
  );
}

export default Footer;